var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
export var CheckoutForm = function (_a) {
    var setPaymentIntent = _a.setPaymentIntent;
    var stripe = useStripe();
    var elements = useElements();
    var _b = useState(undefined), message = _b[0], setMessage = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    e.preventDefault();
                    if (!stripe || !elements) {
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    return [4 /*yield*/, stripe.confirmPayment({
                            elements: elements,
                            redirect: 'if_required'
                        })];
                case 1:
                    result = _d.sent();
                    if (result.error && (((_a = result.error) === null || _a === void 0 ? void 0 : _a.type) === "card_error" || ((_b = result.error) === null || _b === void 0 ? void 0 : _b.type) === "validation_error")) {
                        setMessage((_c = result.error) === null || _c === void 0 ? void 0 : _c.message);
                    }
                    else if (result.error) {
                        setMessage("An unexpected error occurred.");
                    }
                    setIsLoading(false);
                    if (!result.error && result) {
                        setPaymentIntent(result);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var paymentElementOptions = {
        layout: "tabs"
    };
    return (_jsxs("form", __assign({ id: "payment-form", onSubmit: function (event) { return handleSubmit(event); } }, { children: [_jsx(PaymentElement, { id: "payment-element", options: paymentElementOptions }), _jsx("button", __assign({ disabled: isLoading || !stripe || !elements, id: "submit" }, { children: _jsx("span", __assign({ id: "button-text" }, { children: isLoading ? _jsx("div", { className: "spinner", id: "spinner" }) : "Pay now" })) })), message && _jsx("div", __assign({ id: "payment-message" }, { children: message }))] })));
};
